import { initialsAvatarDataUrl } from "@compass/shared/utils/initialsAvatar";
import { Link } from "@tanstack/react-router";
import clsx from "clsx";
import { useState } from "react";

const deriveInitials = (name?: string | null): string => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    const first = parts[0]!.charAt(0).toUpperCase();
    const last = parts.length > 1 ? parts[parts.length - 1]!.charAt(0).toUpperCase() : "";
    return first + last;
};

type AvatarType = {
    userId?: number | undefined;
    photoUrl?: string | null;
    className?: string;
    name?: string | null;
    initials?: string;
    seed?: string | number;
};

export const SideAvatar = ({ userId, className, photoUrl, name, initials, seed }: AvatarType) => {
    // PRTL-1349: single <img> with the initials tile as its background while
    // loading and as the fallback on error (see Avatar).
    const [failedUrl, setFailedUrl] = useState<string | null>(null);

    const resolvedInitials = initials ?? deriveInitials(name);
    const fallbackSrc = initialsAvatarDataUrl({
        initials: resolvedInitials,
        seed: seed ?? userId ?? resolvedInitials,
    });
    const showPhoto = !!photoUrl && failedUrl !== photoUrl;

    const body = (
        <img
            className="h-auto w-full rounded-xl bg-cover object-cover shadow-xl"
            src={showPhoto ? photoUrl : fallbackSrc}
            alt={showPhoto ? (name ?? "") : resolvedInitials}
            decoding="async"
            style={showPhoto ? { backgroundImage: `url("${fallbackSrc}")` } : undefined}
            onError={showPhoto ? () => setFailedUrl(photoUrl) : undefined}
        />
    );

    if (userId) {
        return (
            <Link
                to="/profile/edit/$id"
                params={{ id: `${userId}` }}
                className={clsx("flex items-center justify-center", className)}
            >
                {body}
            </Link>
        );
    }
    return <span className={clsx("flex items-center justify-center", className)}>{body}</span>;
};
